
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 20h1V8.5a.5.5 0 01.5-.5h3a.5.5 0 01.447.276l.053.106a1.118 1.118 0 002 0l.053-.106A.5.5 0 0113.5 8h3a.5.5 0 01.5.5V20h1V2.5A1.5 1.5 0 0016.5 1h-9A1.5 1.5 0 006 2.5V20zm0 1v.5A1.5 1.5 0 007.5 23h9a1.5 1.5 0 001.5-1.5V21H6zm2-9h8V9h-2.201A2.118 2.118 0 0110.2 9H8v3zm8 1H8v7h8v-7zm-4.5-9a.5.5 0 010-1h3a.5.5 0 010 1h-3zm-3 0a.5.5 0 010-1h1a.5.5 0 010 1h-1zm8 20h-9A2.5 2.5 0 015 21.5v-19A2.5 2.5 0 017.5 0h9A2.5 2.5 0 0119 2.5v19a2.5 2.5 0 01-2.5 2.5z","fill":"#053976"}})])
          )
        }
      }
    